export const TYPE_DOLARS ={
    "-1": '--',
    0: '--',
    1: 'Banco Nación comprador',
    2: 'Banco Nación vendedor',
    4: 'Circular 3500 BCRA',
    5: 'Siopel',
    6: 'Matba - Rofex'
}